// appVersion: 4.1.1
import Vue from 'vue'
import App from './App.vue'

// === Import Plugin ===
import '@/plugin/dateFns'
import '@/plugin/vue-lazyload'
import '@/plugin/element-ui'
import '@/plugin/highcharts'
import '@/plugin/element-tree-grid'
import '@/plugin/registerServiceWorker'
import '@/plugin/vue-json-csv'
import '@/plugin/vue-lang'
import '@/plugin/vue-dragscroll'
// import '@/plugin/vue-html2canvas'
import VueHtml2Canvas from 'vue-html2canvas'
Vue.use(VueHtml2Canvas)
import '@/plugin/vue-analytics'
import '@/plugin/chart-js'
import '@/plugin/vue-utilities' // Global functions
import '@/plugin/global-variable' // Global variable

// === Import Style ===
import '@/assets/element-variables.scss'
import '@/assets/global-style.scss'
import '@/assets/main.scss'

import router from '@/router'
import store from './store/store'
import firebase from 'firebase/app';
import 'firebase/auth';
// import { Z_DEFAULT_STRATEGY } from 'zlib';
var configFirebase = {
  apiKey:'AIzaSyAE_lkz0jofbcDev5TrQI5FzevgWi8-VQA',
  authDomain: 'admin.happily.ai',
  databaseURL: 'https://people2-admin.firebaseio.com/',
  storageBucket: 'people2-admin.appspot.com',
  projectId: 'people2-admin',
  messagingSenderId: '561345191871'
}
//Dev//
// var configFirebase = {
//   apiKey: 'AIzaSyDYEIH1sSncoewPkzuAvh8l9V-iqEM0eAk',
//   authDomain: 'people2-8d697.firebaseapp.com',
//   databaseURL: 'https://people2-8d697.firebaseio.com/',
//   storageBucket: 'people2-8d697.appspot.com',
//   projectId: 'people2-8d697',
//   messagingSenderId: '456787725615'
// }

/*
var configSecondFirebase = {
  databaseURL: 'https://happily-nav-test.firebaseio.com/',
  projectId: 'happily-nav-test'
}

const secondary = firebase.initializeApp(configSecondFirebase, 'secondary');

const commandDatabase = secondary.firestore()
*/

firebase.initializeApp(configFirebase)
Vue.config.productionTip = false
let app:any
firebase.auth().onAuthStateChanged(()=>{
  if(!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})

